import React, { useState } from "react";
import useStyles from "../styles/styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { handleAppStoreClick } from "../common/appStoreUtils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const Hero = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const settings = useSelector((state) => state.settingsdata.settings);

  return (
    <div>
      <AutoPlaySwipeableViews
        interval={8000}
        index={index}
        enableMouseEvents={true}
        onChangeIndex={(index) => setIndex(index)}
      >
        <div className={classes.heroSlide1}>
          <div className={`${classes.heroContainer} ${classes.spacings}`}>
            <div className={classes.firstHeroContainerOne}>
              <h2 className={classes.h2HeroContainer}>{t("premiumRide")}</h2>
              <p className={classes.p1HeroContainer}> {t(`iosAndAndriod`)}</p>

              <p className={classes.p2HeroContainer}>{t(`HarakaConnect`)}</p>
              <button
                className={classes.heroButton}
                onClick={handleAppStoreClick(settings, "/login?signup=true")}
              >
                {t(`downloadHaraka`)}
              </button>
            </div>
          </div>
        </div>

        <div className={classes.heroSlide2}>
          <div className={`${classes.heroContainer} ${classes.spacings}`}>
            <div className={classes.firstHeroContainerOne}>
              <h2 className={classes.h2HeroContainer}>{t("premiumRide")}</h2>
              <p className={classes.p1HeroContainer}> {t(`iosAndAndriod`)}</p>

              <p className={classes.p2HeroContainer}>{t(`HarakaConnect`)}</p>
              <button
                className={classes.heroButton}
                onClick={handleAppStoreClick(settings, "/login?signup=true")}
              >
                {t(`downloadHaraka`)}
              </button>
            </div>
          </div>
        </div>
      </AutoPlaySwipeableViews>
    </div>
  );
};

export default Hero;
